import { Scope } from '@unform/core'

import { useGetFetchQuery } from '~/hooks/useGetFetchQuery'
import PlacementCategory from '~/modules/retailMedia/components/CampaignForm/elements/Targeting/Category'

import { PUBLISHER_ID_QUERY_KEY } from '../../constants'
import { useRequestAds } from '../../hooks/useRequestAds'

const Category = () => {
  const { initialData, handleURLChange, formRef } = useRequestAds()

  const publisherId = useGetFetchQuery<PublisherId>(PUBLISHER_ID_QUERY_KEY)

  return (
    <Scope path="targeting">
      <PlacementCategory
        initialCategories={[
          {
            id: initialData?.targeting?.categories,
            label: initialData?.targeting?.categories
          }
        ]}
        onChange={data =>
          handleURLChange({
            name: 'category_name',
            value: data?.categories?.[0]?.label
          })
        }
        publisherId={publisherId}
        singleCategory
        formRef={formRef}
      />
    </Scope>
  )
}

export default Category
